import { createStore, GetState, SetState } from '@oneappexchange/lwc-wired';
import { State } from 'zustand';
import { IS_DEVELOPMENT } from '~/modules/config';
import { getTopSearches } from '../services/topSearchesService';

export interface TopSearchesState extends State {
    topSearches: string[];
}

const initialState: TopSearchesState = {
    topSearches: [],
};

export const selectTopSearches = (state: TopSearchesState): string[] => {
    return state.topSearches;
};

export const topSearchesStore = createStore(
    initialState,

    (set: SetState<TopSearchesState>, get: GetState<TopSearchesState>) => ({
        async fetchTopSearches() {
            const existingTopSearches = selectTopSearches(get());
            if (!existingTopSearches || existingTopSearches.length === 0) {
                const result = await getTopSearches();
                set(function updateTopSearches(draft: TopSearchesState) {
                    draft.topSearches = result?.searches ?? [];
                });
            }
        },

        updateTopSearches(topSearches: string[]) {
            set(function updateTopSearches(draft: TopSearchesState) {
                draft.topSearches = topSearches;
            });
        },

        reset() {
            set(function resetStore() {
                return { ...initialState };
            });
        },
    }),
    'topSearchesStore',
    IS_DEVELOPMENT,
);
